/* eslint-disable no-console */
import * as actionDelivery from '../actions/deliveryAction';
import HttpService from './HttpService';
import { getUrlExpeditionApi, showMessageToastCustom, translate } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';

const httpService = new HttpService(getUrlExpeditionApi(window));
export default class RouteDeliveryService {
    static getRouteLocationTarget(filter, callback) {
        const url = '/api/routelocationtarget';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionDelivery.setRouteLocationTargets(response.data.data));
                        if (callback) {
                            callback(response);
                        }
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static addRouteLocationTarget(routeLocationTarget, callback) {
        const url = '/api/routelocationtarget/';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, routeLocationTarget).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updateRouteLocationTarget(route, callback) {
        const url = '/api/routelocationtarget/';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, route).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static deleteRouteLocationTarget(routeIdLocationTarget, callback) {
        const url = '/api/routelocationtarget/' + routeIdLocationTarget;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(url).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }
}